<template>
  <div>
    <sirui-table
      ref="siruiTable"
      :data="auditRecordData"
      :paging="false"
      :setting="false"
      :customVisible="false"
      :columns="searchColumn"
      style="margin-top: -50px"
      height="200"
    >
      <!-- <vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column> -->
      <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
      <vxe-table-column
        v-for="(item, index) in searchColumn"
        :key="index"
        :fixed="item.fixed"
        :sortable="item.sortable"
        :field="item.field"
        :title="item.title ? $t(item.title) : null"
        :visible="item.visible"
        :type="item.type"
        :width="item.width"
      >
        <!-- <template v-slot="{ row }">
                <template v-if="item.field == 'fileList'">
                  <span
                    v-for="(item1, index) in row[item.field]"
                    :key="index"
                    @click="uploadFile(row, index)"
                  >
                    <span style="color: #009fcc">{{ item1.attachmentName }}</span
                    >&nbsp;&nbsp;&nbsp;&nbsp;
                  </span>
                </template>
                <template v-else>{{ row[item.field] }}</template>
              </template> -->
      </vxe-table-column>
    </sirui-table>
  </div>
</template>

<script>
  export default {
    name: 'approvalRecord',
    props: ['detailApprovalRecords'],
    data() {
      return {
        auditRecordData: [],
        searchColumn: [
          {
            field: 'operaterName',
            title: '操作人',
            visible: true,
          },
          {
            field: 'approvalItemName',
            title: '操作',
            visible: true,
          },
          {
            field: 'operaterDate',
            title: '操作时间',
            visible: true,
          },
          {
            field: 'approvalComment',
            title: '审批信息',
            visible: true,
          },
        ],
      };
    },
    watch: {
      detailApprovalRecords: {
        handler(newValue, oldValue) {
          console.log('监听', newValue, oldValue);
          this.dealData(newValue);
        },
        deep: true,
        immediate: true,
        //   if (newVal) {
        //     this.dealData(newVal);
        //   }
      },
    },
    methods: {
      dealData(list) {
        console.log(list, 'listlist');
        this.auditRecordData = list;
      },
      getName(val) {
        console.log('val--', val);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .title {
    font-size: 20px;
    font-weight: 600;
  }
</style>
